module.exports = __webpack_public_path__ + "static/hut-audio-813fd2472ac57eaef88717477187cb54.mp3";